import axios from 'axios'

import { API_ROUTES, BASE_API_CONFIG } from '../../shared/utils/api'

export default {
  DEFAULT_ORDER: 'desc',

  fetchAll(optional_params = {}) {
    return axios.request({
      ...BASE_API_CONFIG,
      method: 'GET',
      url: API_ROUTES.video_resource_articles(optional_params.episode_id),
    })
  },
}
